<template>
    <div class="rd-auth">
        <loading
            :active.sync="open_loader"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#6366f1'"
        ></loading>

        <div class="rd-auth__card">
            <div class="rd-auth__brand">
                <img :src="logo" alt="logo" class="rd-auth__logo" />
            </div>

            <h1 class="rd-auth__title">Prijava</h1>
            <p class="rd-auth__sub">Dobrodošli natrag — prijavite se u sustav.</p>

            <form class="rd-auth__form" @submit.prevent="login">
                <div class="rd-field">
                    <label for="email">E-mail</label>
                    <input id="email" type="text" name="email" v-model="email" required autofocus
                           placeholder="vasa@adresa.hr" />
                    <span v-if="errors && errors.email" class="rd-error">{{ errors.email[0] }}</span>
                </div>

                <div class="rd-field">
                    <label for="password">Lozinka</label>
                    <input id="password" type="password" name="password" v-model="password" required
                           placeholder="••••••••" />
                    <span v-if="errors && errors.password" class="rd-error">{{ errors.password[0] }}</span>
                </div>

                <div class="rd-auth__forgot">
                    <a role="button" @click="forgotPassword">Zaboravili ste lozinku?</a>
                </div>

                <button type="submit" class="rd-auth__btn rd-auth__btn--primary" @click.prevent="login">
                    Prijavi se
                </button>
            </form>

            <div class="rd-divider"><span>Nemate račun?</span></div>

            <button class="rd-auth__btn rd-auth__btn--ghost" @click.prevent="register">
                Registrirajte se
            </button>
        </div>
    </div>
</template>

<script>
import {mapMutations} from "vuex";
import axios from "axios";
import Loading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "Login",
    components: {
        Loading
    },
    data: function () {
        return {
            email: null,
            password: null,
            errors: null,
            open_loader: false,
        }
    },
    computed: {
        logo() {
            const owner = process.env.VUE_APP_APP_OWNER;
            const file = owner === 'HKIE' ? 'hkie.png' : 'hkig.png';
            return require('@/img/logo/' + file);
        }
    },
    methods: {
        ...mapMutations("auth", ["setUserData"]),

        login() {
            let vm = this;
            vm.open_loader = true;
            axios.post(process.env.VUE_APP_API_URL + "login", {
                email: vm.email,
                password: vm.password
            })
                .then(response => {
                    if (response.data.success) {
                        vm.$store.commit("auth/setUserData", response.data.data.user);
                        localStorage.setItem("access_token", response.data.data.access_token);
                        vm.$router.push('/')
                    } else {
                        vm.errors = response.data.messages
                    }
                    vm.open_loader = false
                })
                .catch(function (error) {
                    if (error instanceof Error) {
                        console.log('Error: ' + error);
                    } else {
                        console.log('Unexpected response: ' + error);
                    }
                    vm.open_loader = false
                })
        },

        forgotPassword() {
            this.$router.push('forgot-password')
        },

        register() {
            this.$router.push('register')
        }
    },

    mounted() {

    },

}
</script>

<style scoped>
.rd-auth {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
}

.rd-auth__card {
    width: 100%;
    max-width: 430px;
    background: #fff;
    border: 1px solid var(--rd-border, #e6e8f0);
    border-radius: var(--rd-radius, 18px);
    box-shadow: var(--rd-shadow-lg, 0 24px 48px -12px rgba(31,28,86,.28));
    padding: 2.5rem 2.25rem;
}

.rd-auth__brand {
    display: flex;
    justify-content: center;
    margin-bottom: 1.25rem;
}
.rd-auth__logo { height: 64px; width: auto; }

.rd-auth__title {
    text-align: center;
    font-size: 1.6rem;
    font-weight: 800;
    margin: 0;
}
.rd-auth__sub {
    text-align: center;
    color: var(--rd-muted, #6b7280);
    margin: .35rem 0 1.75rem;
    font-size: .95rem;
}

.rd-field { margin-bottom: 1.1rem; display: flex; flex-direction: column; }
.rd-field label { margin: 0 0 .4rem; font-weight: 600; color: #3a4253; }

.rd-error { color: var(--rd-danger, #ef4444); font-size: .82rem; margin-top: .35rem; font-weight: 600; }

.rd-auth__forgot { text-align: right; margin: -.3rem 0 1.25rem; }
.rd-auth__forgot a { font-size: .85rem; font-weight: 600; cursor: pointer; }

.rd-auth__btn {
    width: 100%;
    border: none;
    border-radius: var(--rd-radius-sm, 12px);
    padding: .8rem 1rem;
    font-weight: 700;
    font-size: .98rem;
    cursor: pointer;
    transition: transform .12s ease, filter .2s ease, background .2s ease;
}
.rd-auth__btn--primary {
    color: #fff;
    background: var(--rd-gradient, linear-gradient(135deg, #6366f1, #7c3aed));
    box-shadow: 0 10px 22px -8px rgba(99,102,241,.7);
}
.rd-auth__btn--primary:hover { transform: translateY(-1px); filter: brightness(1.05); }
.rd-auth__btn--ghost {
    color: var(--rd-primary-600, #4f46e5);
    background: var(--rd-primary-50, #eef2ff);
}
.rd-auth__btn--ghost:hover { background: #e3e7ff; }

.rd-divider {
    display: flex;
    align-items: center;
    text-align: center;
    color: var(--rd-muted, #6b7280);
    font-size: .85rem;
    margin: 1.5rem 0 1rem;
}
.rd-divider::before, .rd-divider::after {
    content: "";
    flex: 1;
    height: 1px;
    background: var(--rd-border, #e6e8f0);
}
.rd-divider span { padding: 0 .85rem; }
</style>
